<li>
    <div *ngIf="menu.url == null" class="menu-item" (click)="toggleSubMenu()" >
        <span *ngIf="menu.icon" [class]="menu.icon"></span>
        <span class="menu-name">{{ menu.name }}</span>
        
        <span class="expand-icon">{{ isExpanded ? '▼' : '▶' }}</span>
    </div>

    <div *ngIf="menu.url != null && menu.isRoot == true && menu.subMenu.length == 0" class="menu-item" (click)="navigateToMenu(menu.url)">
        <span *ngIf="menu.icon" [class]="menu.icon"></span>
        <span class="menu-name">{{ menu.name }}</span>
    </div>  

    <div *ngIf="menu.url != null && menu.isRoot == false" class="menu-item" [routerLink]="menu.url">
        <span *ngIf="menu.icon" [class]="menu.icon"></span>
        <span class="menu-name">{{ menu.name }}</span>
    </div>

    <ul *ngIf="isExpanded && menu.subMenu.length > 0" class="submenu">
        <ng-container *ngFor="let subMenu of menu.subMenu">
            <dynamic-sidebar-item [menu]="subMenu"></dynamic-sidebar-item>
        </ng-container>
    </ul>
</li>